export default __webpack_public_path__ + "13e6a7152e29d21c5eedb11d5848446b.svg";